/* ============================================================
   THEME.JS — FATEBOX
   ============================================================ */

'use strict';

// --- Mobile Nav Toggle ---
(function () {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav-menu]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target) && !toggle.contains(e.target)) {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });
})();

// --- Gender Toggle (Product Form) ---
(function () {
  const genderBtns = document.querySelectorAll('.gender-btn');
  const genderInput = document.querySelector('[data-gender-input]');
  if (!genderBtns.length || !genderInput) return;

  genderBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      genderBtns.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      genderInput.value = btn.dataset.value;
    });
  });

  // Set default
  if (genderBtns[0]) {
    genderBtns[0].classList.add('active');
    genderInput.value = genderBtns[0].dataset.value;
  }
})();

// --- Product Form Validation ---
(function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  // 티저 페이지를 경유할 상품 (product.{suffix}.json 의 suffix).
  // 여기에 없는 상품은 기존 동작(장바구니 → 결제)을 그대로 탄다.
  // 전체 상품에 적용할 때는 이 목록을 넓히고 같은 이름 규칙으로
  // 페이지·템플릿(page.teaser-{suffix}.json)만 만들면 된다. JS는 고칠 필요 없다.
  const TEASER_PRODUCTS = ['love'];

  form.addEventListener('submit', (e) => {
    const nameInput = form.querySelector('[name="properties[姓名]"]');
    const dateInput = form.querySelector('[name="properties[出生日期]"]');
    let valid = true;

    // 고객 정보 검증
    if (nameInput && !nameInput.value.trim()) {
      showFieldError(nameInput, '請輸入您的姓名');
      valid = false;
    }
    if (dateInput && !dateInput.value) {
      showFieldError(dateInput, '請選擇出生日期');
      valid = false;
    }

    // 관상 입력 검증 (face form IIFE에서 expose한 함수 사용)
    if (typeof window._faceFormValid === 'function' && !window._faceFormValid()) {
      if (typeof window._faceFormShowError === 'function') window._faceFormShowError();
      valid = false;
    }

    if (!valid) {
      e.preventDefault();
      // 첫번째 오류 위치로 스크롤
      const firstErr = form.querySelector('.form-error, .face-step__error-msg:not([hidden])');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // 티저 대상이 아니면 여기서 끝 — 기존 동작(장바구니 담기)으로 진행한다.
    if (!TEASER_PRODUCTS.includes(form.dataset.teaser || '')) return;

    e.preventDefault();
    goToTeaser(form);
  });

  /**
   * 입력값을 App Proxy로 보내고 티저 페이지로 이동한다.
   * 실패하면 기존 결제 흐름으로 폴백해 매출이 유실되지 않게 한다.
   */
  function goToTeaser(form) {
    const btn = form.querySelector('button[type="submit"]');
    const btnText = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = '命盤計算中…';
    }

    const variantInput = form.querySelector('[name="id"]');
    const payload = {
      productType: form.dataset.teaser,
      variantId: variantInput ? variantInput.value : '',
    };

    // properties[...] 입력을 그대로 수집한다.
    // 키 이름은 서버(getProp)와 1:1로 맞아야 하므로 가공하지 않는다.
    form.querySelectorAll('[name^="properties["]').forEach((el) => {
      const matched = el.name.match(/^properties\[(.+)\]$/);
      if (!matched) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      const value = (el.value || '').trim();
      if (value) payload[matched[1]] = value;
    });

    fetch('/apps/saju/teaser', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then((data) => {
        if (!data || !data.ok || !data.teaserId) throw new Error('티저 생성 실패');

        // 상품마다 티저 페이지를 분리한다 (디자인이 상품별로 달라지므로).
        //   love → /pages/teaser-love  (템플릿: page.teaser-love.json)
        // 상품을 추가할 때는 TEASER_PRODUCTS 목록에 넣고 같은 이름 규칙으로
        // 페이지·템플릿을 만든 뒤, 관리자에서 페이지에 템플릿을 지정하면 된다.
        const slug = 'teaser-' + form.dataset.teaser;

        window.location.href =
          '/pages/' + encodeURIComponent(slug) +
          '?id=' + encodeURIComponent(data.teaserId);
      })
      .catch((err) => {
        // 티저가 실패해도 구매는 되어야 한다 → 기존 흐름으로 폴백.
        // form.submit()은 submit 이벤트를 다시 발생시키지 않으므로 무한 루프가 없다.
        console.error('[teaser] 생성 실패 — 기존 결제 흐름으로 진행', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = btnText;
        }
        form.submit();
      });
  }

  function showFieldError(input, message) {
    input.style.borderColor = '#ff6b6b';
    let err = input.parentElement.querySelector('.form-error');
    if (!err) {
      err = document.createElement('span');
      err.className = 'form-error';
      err.style.cssText = 'color:#ff6b6b;font-size:0.75rem;margin-top:4px;display:block';
      input.parentElement.appendChild(err);
    }
    err.textContent = message;
    input.addEventListener('input', () => {
      input.style.borderColor = '';
      if (err) err.remove();
    }, { once: true });
  }
})();

// --- Cart: Line Item Properties Display ---
(function () {
  // Highlight order total
  const total = document.querySelector('[data-cart-total]');
  if (total) {
    total.style.color = 'var(--color-gold)';
    total.style.fontWeight = '700';
  }
})();

// --- FAQ Accordion ---
(function () {
  const items = document.querySelectorAll('[data-faq-item]');
  if (!items.length) return;

  items.forEach((item, index) => {
    const toggle = item.querySelector('[data-faq-toggle]');
    const answer = item.querySelector('[data-faq-answer]');
    if (!toggle || !answer) return;

    // Ensure aria-controls/id pairing
    const answerId = answer.id || 'faq-answer-' + (index + 1);
    answer.id = answerId;
    toggle.setAttribute('aria-controls', answerId);

    toggle.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Close all others
      items.forEach((other) => {
        other.classList.remove('is-open');
        other.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        other.querySelector('[data-faq-answer]').style.maxHeight = '0';
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

// --- Product Accordion ---
(function () {
  const items = document.querySelectorAll('[data-product-accordion-item]');
  if (!items.length) return;

  items.forEach((item, index) => {
    const toggle = item.querySelector('[data-product-accordion-toggle]');
    const answer = item.querySelector('[data-product-accordion-content]');
    if (!toggle || !answer) return;

    // Ensure aria-controls/id pairing
    const answerId = answer.id || 'product-accordion-' + (index + 1);
    answer.id = answerId;
    toggle.setAttribute('aria-controls', answerId);

    toggle.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach((other) => {
        other.classList.remove('is-open');
        other.querySelector('[data-product-accordion-toggle]').setAttribute('aria-expanded', 'false');
        other.querySelector('[data-product-accordion-content]').style.maxHeight = '0';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

// --- Face Form (관상 입력 STEP 1-7) ---
(function () {
  const faceForm = document.querySelector('[data-face-form]');
  if (!faceForm) return;

  const steps = Array.from(faceForm.querySelectorAll('[data-step]'));
  const progressEl = faceForm.querySelector('[data-face-progress]');
  const fillEl = faceForm.querySelector('[data-face-progress-fill]');
  const completeEl = faceForm.querySelector('[data-face-complete]');
  const TOTAL = steps.length;
  let currentIndex = 0;

  function showStep(index) {
    steps.forEach(function (s, i) {
      i === index ? s.removeAttribute('hidden') : s.setAttribute('hidden', '');
    });
    if (completeEl) completeEl.setAttribute('hidden', '');
    currentIndex = index;
    updateProgress();
    faceForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function showComplete() {
    steps.forEach(function (s) { s.setAttribute('hidden', ''); });
    if (completeEl) completeEl.removeAttribute('hidden');
    if (progressEl) progressEl.textContent = 'STEP ' + TOTAL + ' / ' + TOTAL + ' ✦';
    setFill(TOTAL);
    highlightCTA();
  }

  function updateProgress() {
    if (progressEl) progressEl.textContent = 'STEP ' + (currentIndex + 1) + ' / ' + TOTAL;
    setFill(currentIndex + 1);
  }

  // 진행바 폭. 막대가 없어도(마크업이 옛 버전이어도) 스텝 이동은 그대로 돌아간다.
  function setFill(n) {
    if (fillEl) fillEl.style.width = (n / TOTAL * 100) + '%';
  }

  function validateCurrentStep() {
    const step = steps[currentIndex];
    const prop = step.querySelector('[data-face-prop]');
    const errEl = step.querySelector('[data-step-error]');
    if (!prop || !prop.value) {
      if (errEl) errEl.removeAttribute('hidden');
      // 흔들기 효과
      const options = step.querySelector('[data-options]');
      if (options) {
        options.classList.add('shake');
        setTimeout(function () { options.classList.remove('shake'); }, 400);
      }
      return false;
    }
    if (errEl) errEl.setAttribute('hidden', '');
    return true;
  }

  function highlightCTA() {
    const ctaBtn = document.querySelector('[name="add"]');
    if (!ctaBtn) return;
    setTimeout(function () {
      ctaBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      ctaBtn.classList.add('cta-pulse');
      setTimeout(function () { ctaBtn.classList.remove('cta-pulse'); }, 2500);
    }, 400);
  }

  // 옵션 선택
  faceForm.addEventListener('change', function (e) {
    const radio = e.target;
    if (!radio.matches('input[type="radio"]')) return;
    const step = radio.closest('[data-step]');
    const prop = step.querySelector('[data-face-prop]');
    if (prop) prop.value = radio.value;

    step.querySelectorAll('.face-option-card').forEach(function (c) {
      c.classList.remove('is-selected');
    });
    radio.closest('.face-option-card').classList.add('is-selected');

    // 인라인 에러 지우기
    const errEl = step.querySelector('[data-step-error]');
    if (errEl) errEl.setAttribute('hidden', '');

    // 마지막 스텝에서 전체 완료 확인
    if (currentIndex === TOTAL - 1) {
      const allDone = Array.from(faceForm.querySelectorAll('[data-face-prop]'))
        .every(function (inp) { return inp.value; });
      if (allDone) {
        setTimeout(showComplete, 300);
      }
    }
  });

  // 이전/다음/수정 버튼
  faceForm.addEventListener('click', function (e) {
    if (e.target.closest('[data-face-next]')) {
      if (!validateCurrentStep()) return;
      if (currentIndex < TOTAL - 1) showStep(currentIndex + 1);
    }
    if (e.target.closest('[data-face-prev]')) {
      if (currentIndex > 0) showStep(currentIndex - 1);
    }
    if (e.target.closest('[data-face-edit]')) {
      showStep(TOTAL - 1);
    }
  });

  // Product Form Validation IIFE에서 사용할 함수 노출
  window._faceFormValid = function () {
    return Array.from(faceForm.querySelectorAll('[data-face-prop]'))
      .every(function (inp) { return inp.value; });
  };
  window._faceFormShowError = function () {
    const props = Array.from(faceForm.querySelectorAll('[data-face-prop]'));
    const firstInvalidIdx = props.findIndex(function (inp) { return !inp.value; });
    if (firstInvalidIdx !== -1) {
      showStep(firstInvalidIdx);
      const errEl = steps[firstInvalidIdx].querySelector('[data-step-error]');
      if (errEl) errEl.removeAttribute('hidden');
    }
  };
})();

// --- Smooth scroll for anchor links ---
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
